module.exports = __webpack_public_path__ + "img/responsive-mobile-lazy.4e561888.jpg";